import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import {
  Form,
  FormGroup,
  Navbar,
  Container,
  Media
} from "reactstrap";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import axios from "utils/api";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
}));

const merchantName = {
  color: "white",
  fontWeight: 500,
};


const AdminNavbar = props => {
  let history = useHistory();
  const authSession = JSON.parse(localStorage.getItem('auth'));

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if (authSession === null)
        history.push('/auth/login');
    }
    
    return () => { mounted = false; };
  }, []);

  const handleSignOut = () => {
    var answer = window.confirm("Are you sure you want to sign out?");
    if (answer) {
      var auditlog = { 
        moduleName: `Main Page`,
        accountId: authSession?.merchantGroupCode,
        username: authSession?.username,
        actionsTaken: `Logout`
      };
  
      axios.post('auditlog/add', { auditlog: auditlog }).then(() => { });
  
      setTimeout(() => {
        localStorage.clear();
  
        window.location.href = '/auth/login';
      }, 2000);
    }
  };

  return (
    <>
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Container fluid>
          <Link
            className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block"
            to="/"
          >
            {props.brandText}
          </Link>
          <Form className="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
            <FormGroup className="mb--1">
              <h2 style={merchantName}>
                { authSession?.merchantName }
              </h2>
            </FormGroup>
          </Form>

          <Media className="align-items-center">
            {/* <span className="avatar avatar-sm rounded-circle">
              <img
                alt={authSession?.merchantName}
                src={require("assets/img/theme/3443569.png")}
              />
            </span> */}
            <Media className="ml-2 d-none d-lg-block">
              <span className="mb-0 text-sm font-weight-bold text-white">
                { authSession?.username } | { authSession?.emailAddress } | 
              </span>
            </Media>
            <Button 
              size="small" 
              className="ml-2 mb--1 text-white" 
              startIcon={<LogoutIcon />}
              onClick={() => handleSignOut() } 
           >
             Sign out
            </Button>
          </Media>
        </Container>
      </Navbar>
    </>
  );
}

export default AdminNavbar;
